import request from '@/utils/request'

export function payermaxIntents (data = {}) {
  return request({
    url: '/pay/payermax/create/paymentIntents',
    data
  })
}
